import Phaser from 'phaser';
import { titleStyle } from './MenuScene';
import { configureLogicalCamera } from '../systems/DisplayManager';

interface ResultData { score: number }

export class ResultScene extends Phaser.Scene {
  constructor() {
    super('Result');
  }

  create(data: ResultData): void {
    configureLogicalCamera(this);
    this.add.image(240, 135, 'menu-bg').setDisplaySize(480, 270);
    this.add.rectangle(240, 135, 480, 270, 0x03101b, 0.55);
    this.add.rectangle(240, 136, 420, 205, 0x071827, 0.9).setStrokeStyle(3, 0xd5a841);
    this.add.text(240, 61, 'ŚWIT NAD BIELSKIEM!', titleStyle(18, '#f2c85b')).setOrigin(0.5).setStroke('#17333f', 5);
    this.add.text(240, 96, 'Kumek i Bąbel odprowadzili wszystkie\npsotne ornamenty na ich miejsca.', {
      ...titleStyle(9, '#e8eed8'),
      align: 'center',
      lineSpacing: 6,
    }).setOrigin(0.5);
    this.add.text(240, 149, 'WYNIK KOŃCOWY', titleStyle(9, '#8fb6a7')).setOrigin(0.5);
    this.add.text(240, 173, data.score.toString().padStart(7, '0'), titleStyle(20, '#8fe17f')).setOrigin(0.5);
    this.add.text(240, 219, 'ENTER · WRÓĆ DO MIASTA', titleStyle(8, '#f6e5b6')).setOrigin(0.5);
    this.input.keyboard?.once('keydown-ENTER', () => this.scene.start('Menu'));
    this.input.once('pointerdown', () => this.scene.start('Menu'));
  }
}
